var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dimmer active",class:{'absolute-loading': _vm.positionAbsolute}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner4"},[_c('div',{staticClass:"bounce1"}),_c('div',{staticClass:"bounce2"}),_c('div',{staticClass:"bounce3"})])
}]

export { render, staticRenderFns }